<template>
  <layout-general>
    <preview-header slot="header" />
    <top-bar slot="top" />
    <main-stage :show-duration="false" slot="main" />
    <left-bar slot="left" />
    <bottom-bar slot="bottom" />
    <done slot="footer" />
  </layout-general>
</template>

<script>
import LayoutGeneral from 'AssetEditor/layouts/LayoutGeneral.vue';
import LeftBar from 'AssetEditor/functionality/Preview/LeftBar.vue';
import PreviewHeader from 'AssetEditor/functionality/Preview/Header.vue';
import BottomBar from 'AssetEditor/functionality/Preview/BottomBar.vue';
import TopBar from 'AssetEditor/functionality/Preview/TopBar.vue';
import Done from 'AssetEditor/functionality/Preview/Done.vue';
import MainStage from 'AssetEditor/functionality/Stage/MainStage.vue';

export default {
  components: {
    LayoutGeneral,
    PreviewHeader,
    LeftBar,
    BottomBar,
    TopBar,
    Done,
    MainStage,
  },
};
</script>
